import SVG112Story from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/half-story.svg';
import SVG9Ceilings from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/9-ft-ceiling.svg';
import SVGBonusRoom from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/bonus-room.svg';
import SVGBreakfastBar from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/breakfast-bar.svg';
import SVGComputerStation from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/computer-station.svg';
import SVGCoveredPorch from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/porch.svg';
import SVGDefaultFeature from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/default-feature.svg';
import SVGDiningRoom from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/dining-room.svg';
import SVGDoubleSinks from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/double-sink.svg';
import SVGDoublePrimaryClosets from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/double-master-closets.svg';
import SVGDrywall from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/drywall.svg';
import SVGEndExit from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/end-exit.svg';
import SVGEntertainmentCenter from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/default-feature.svg';
import SVGFamilyRoom from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/family-room.svg';
import SVGFireplace from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/fireplace.svg';
import SVGFoyer from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/foyer.svg';
import SVGGarage from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/garage.svg';
import SVGKitchenIsland from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/kitchen-island.svg';
import SVGMasterBedroomRetreat from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/master-bedroom.svg';
import SVGModularConstruction from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/modular.svg';
import SVGNursery from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/nursery.svg';
import SVGOffice from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/office.svg';
import SVGOpenFloorplan from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/open-floorplan.svg';
import SVGPantry from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/pantry.svg';
import SVGSeparateShowerTub from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/separate-shower-bath.svg';
import SVGSideExit from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/side-exit.svg';
import SVGSplitBedroom from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/split-bedroom.svg';
import SVGTrayCeilings from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/tray-ceiling.svg';
import SVGTwoStory from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/two-story.svg';
import SVGUtilityRoom from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/utility-room.svg';
import SVGVaultedCeilings from 'pubweb-smokey/dist/images/svg/iconography-features-48x48/vault-ceiling.svg';

export default [
  { tagName: '1 1/2 Story', icon: SVG112Story },
  { tagName: "9' Ceilings", icon: SVG9Ceilings },
  { tagName: 'Bonus Room', icon: SVGBonusRoom },
  { tagName: 'Breakfast Bar', icon: SVGBreakfastBar },
  { tagName: 'Computer Nook', icon: SVGDefaultFeature },
  { tagName: 'Computer Station', icon: SVGComputerStation },
  { tagName: 'Cooking Island', icon: SVGDefaultFeature },
  { tagName: 'Covered Entry', icon: SVGVaultedCeilings },
  { tagName: 'Covered Porch', icon: SVGCoveredPorch },
  { tagName: 'Dining Room', icon: SVGDiningRoom },
  { tagName: 'Double Sinks in Bath', icon: SVGDoubleSinks },
  { tagName: 'Double Primary Closets', icon: SVGDoublePrimaryClosets },
  { tagName: 'Drywall', icon: SVGDrywall },
  { tagName: 'EndExit', icon: SVGEndExit },
  { tagName: 'Entertainment Unit', icon: SVGEntertainmentCenter },
  { tagName: 'Family Room', icon: SVGFamilyRoom },
  { tagName: 'Fireplace', icon: SVGFireplace },
  { tagName: 'Foyer', icon: SVGFoyer },
  { tagName: 'Garage', icon: SVGGarage },
  { tagName: 'Kitchen Island', icon: SVGKitchenIsland },
  { tagName: 'Modular Construction', icon: SVGModularConstruction },
  { tagName: 'Nursery', icon: SVGNursery },
  { tagName: 'Office', icon: SVGOffice },
  { tagName: 'Open Floor Plan', icon: SVGOpenFloorplan },
  { tagName: 'Pantry', icon: SVGPantry },
  { tagName: 'Primary Bedroom Retreat', icon: SVGMasterBedroomRetreat },
  { tagName: 'Separate Tub and Shower', icon: SVGSeparateShowerTub },
  { tagName: 'SideExit', icon: SVGSideExit },
  { tagName: 'Split Bedrooms', icon: SVGSplitBedroom },
  { tagName: 'Tray Ceilings', icon: SVGTrayCeilings },
  { tagName: 'Two Story', icon: SVGTwoStory },
  { tagName: 'Utility Room', icon: SVGUtilityRoom },
  { tagName: 'Vaulted Ceilings', icon: SVGVaultedCeilings },
  { tagName: 'Default Feature', icon: SVGDefaultFeature },
];
